module.exports = __webpack_public_path__ + "5d92333b400fadafd27210f7702f1320.png";